/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var UiMenuShapeCircle4Icon24Solid = forwardRef('UiMenuShapeCircle4Icon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M22 6.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Z" }),
        React.createElement("path", { d: "M6.5 22a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Z" }),
        React.createElement("path", { d: "M17.5 22a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Z" }),
        React.createElement("path", { d: "M6.5 11a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Z" })));
});
